import styled from 'styled-components';

const Headline = styled.span`
  margin: 0px;
  line-height: 1;
  color: ${p => (p.style.color ? p.style.color : 'rgba(0, 0, 0, 0.65)')};
  margin-bottom: 5px;
  font-weight: 600;
  word-wrap: break-word;
  font-size: 30px;
`;

Headline.defaultProps = {
  style: {},
  size: null,
};

export default Headline;



// WEBPACK FOOTER //
// ./src/components/text/Headline/index.js